import { useMemo, useRef, useState } from "react";
import usePersistStickyFilters from "./usePersistStickyFilters";
import { persistVendorStickyFilterState } from "../utils/vendorStickyFilterPersistence";

/**
 * Sticky selectedIds for My Vendors / vendor list detail screens.
 * Re-hydrates when screenKey changes (e.g. My Vendors tab switch) without
 * writing the previous tab's selections into the new key.
 */
export default function useStickySelectedIds(screenKey, loadFilterState) {
  const activeKeyRef = useRef(screenKey);
  const [selectedIds, setSelectedIds] = useState(
    () => loadFilterState(screenKey).selectedIds
  );

  if (activeKeyRef.current !== screenKey) {
    activeKeyRef.current = screenKey;
    setSelectedIds(loadFilterState(screenKey).selectedIds);
  }

  const persistedFilterState = useMemo(
    () => ({ selectedIds }),
    [selectedIds]
  );

  usePersistStickyFilters(
    screenKey,
    persistedFilterState,
    persistVendorStickyFilterState
  );

  return [selectedIds, setSelectedIds];
}
